import axios, { AxiosError } from "axios";
import { REFRESH_ACCESS_TOKEN_ENDPOINT } from "@/properties";
import { getAccessToken, hasAccessToken, needsRefresh, refreshTokenPair, removeTokenPair } from "@/jwt";
import { backToTop } from "@/router";

axios.interceptors.request.use(async (config) => {
  if (!config.url?.startsWith(REFRESH_ACCESS_TOKEN_ENDPOINT) && hasAccessToken() && needsRefresh()) {
    await refreshTokenPair().catch((e) => {
      // トークン更新に失敗した場合は, ログインからやりなおす
      console.error(e);
      backToTop();
      removeTokenPair();
    });
  }
  // JWTアクセストークンをAuthorizationヘッダに付与する
  const accessToken = getAccessToken();
  if (accessToken) {
    config.headers.authorization = accessToken;
  }
  return config;
});

axios.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    // 認証情報がない状態でAPIを呼ぶと発生
    if (error.response!.status === 403) {
      backToTop();
    }
    throw error;
  }
);